import { UseCase } from '@app/core/utils/use-case.utility';
import {
  ConfigurationAuditLog,
  ConfigurationAuditLogParams,
  ConfigurationAuditLogRepository,
} from '@app/domain';
import { PaginatedResponse } from '@app/shared/models/global.model';
import { Observable } from 'rxjs';

export class GetConfigurationAuditLogUseCase
  implements
    UseCase<
      { params: ConfigurationAuditLogParams },
      PaginatedResponse<ConfigurationAuditLog>
    >
{
  readonly SERVICE_NAME = 'GetConfigurationAuditLogUseCase';

  constructor(
    private readonly _configurationAuditLogRepository: ConfigurationAuditLogRepository
  ) {}

  execute(args: {
    params: ConfigurationAuditLogParams;
  }): Observable<PaginatedResponse<ConfigurationAuditLog>> {
    const { params } = args;
    return this._configurationAuditLogRepository.getConfigurationAuditLogList(
      params
    );
  }
}
